import styled from "styled-components";

const BgContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;

export default BgContainer;
